"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldHomeOffice = OfferFieldHomeOffice;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const offer_1 = require("@src/types/offer");
function OfferFieldHomeOffice() {
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, curValues) => prevValues[offer_1.EOfferBasicInfoFormField.offerTypeId] !== curValues[offer_1.EOfferBasicInfoFormField.offerTypeId], children: ({ getFieldValue }) => ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { hidden: getFieldValue(offer_1.EOfferBasicInfoFormField.offerTypeId) === offer_1.EOfferType.work_and_travel, name: offer_1.EOfferBasicInfoFormField.homeOffice, valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.home_office" }) }) })) }));
}
